<template>
  <div class="chatListContainer" :class="{ collapsed: isCollapsed }">
    <!-- 收起/展开按钮 -->
    <div class="toggle-button" :class="{ active: isCollapsed }" @click="toggleCollapse">
      <img :src="isCollapsed ? expandIcon : collapseIcon" alt="toggle" />
    </div>
    <div class="buttons" v-show="!isCollapsed">
      <img src="../../assets/images/robot.png" alt="新建聊天" />
      <button @click="createNewChat">新建聊天</button>
      <img src="../../assets/images/kb-icon-blue.png" alt="知识库" />
      <button @click="goToKnowledgeBase">知识库</button>
      <img  src="../../assets/images/knowledgePlanet.png" alt="BIM星球" />
      <button  @click="goToBimPlanet">BIM星球</button>
    </div>
    <div class="chatList" v-show="!isCollapsed">
      <div v-for="chat in chats" :key="chat.id" 
        @mouseover="chat.hovered = true" @mouseleave="chat.hovered = false"
        :style="{backgroundColor: chat.id === $store.state.currentChatId ? 'rgba(50, 108, 255, 0.144)' : ''}"
        @click="setCurrentChatId(chat.id)"
        class="chat-item">
        <div class="chat-title">{{ chatTitleTrim(chat.title) }}</div>
        <div class="chat-date">{{ formatDate(chat.created_at) }}</div>
        <div v-show="chat.hovered"  class="delete-chat">
          <button @click="showDeleteWarningCard(chat.id)"></button>
        </div>
        <div v-show="chat.hovered" class="modify-title">
          <button @click="showTitleInputCard(chat.id)"></button>
        </div>
      </div>
    </div>
    <div v-if=showDeleteWarning class="deleteChatWarning">
      <WarningCard @confirm="verifyDeleteChat" warningMessage="确定删除该条记录？" />
    </div>
    <div v-show="showInputCard" class="inputCard">
      <InputCard inputMessage="请输入修改标题"  @confirm="verifyUpdateChatTitle"/>
  </div>
  </div>
</template>

<script>
import { createChat,getChatList,deleteChat,updateChatTitle} from '@/api/auth';
import WarningCard from '../pannels/WarningCard.vue';
import InputCard from '../pannels/InputCard.vue';
export default {
  components: {
    WarningCard,
    InputCard
  },
  data() {
    return {
      chats: [
        // { id: 1, title: "Chat 1", date: new Date(),hovered:false },
        // { id: 2, title: "Chat 2", date: new Date(),hovered:false },
        // { id: 3, title: "Chat 3", date: new Date(),hovered:false },
        // Add more chat objects here
      ],
      showDeleteWarning:false,
      confirmDelete:false,
      chatId:'',
      showInputCard:false,
      expandIcon: require('../../assets/images/show_chatlist.png'),
      collapseIcon: require('../../assets/images/hide_chatlist.png')
    };
  },
  mounted() {
    this.getUserChatList();
  },
  methods: {
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },
    chatTitleTrim(chatTitle) {
      if(chatTitle.length > 10){
        return chatTitle.substring(0,10) + '...';
      }
      else{
        return chatTitle;
      }
    },
    removeThinkContent(text) {
      return text.replace(/<think>.*?<\/think>/gs, '');
    },
    showDeleteWarningCard(chatId) {
      this.chatId = chatId;
      this.showDeleteWarning = true;
    },
    showTitleInputCard(chatId) {
      this.chatId = chatId;
      this.showInputCard = true;
    },
    setCurrentChatId(chatId) {
      this.$store.commit('setCurrentChatId', chatId);
      this.$emit('showBimPlanet', false);
      console.log('当前聊天id:',this.$store.state.currentChatId);
    },
    //新建聊天
    createNewChat() {
        const date = new Date();
        const chatTitle = '新聊天' + date.getFullYear() + date.getMonth() + date.getDay() + date.getHours() + date.getMinutes() + date.getSeconds();
        createChat(this.$store.state.userId,chatTitle).then((response) => {
          // Logic for creating a new chat
          this.getUserChatList();
          this.$store.commit('setCurrentChatId', response.chat_id);         
        });
      // Logic for creating a new chat
    },
    //获取左侧列表聊天记录
    getUserChatList() {
      getChatList(this.$store.state.userId).then((response) => {
        this.chats = [];
        response.forEach((chat) => {
          this.chats.push({
            id: chat.id,
            title: chat.title,
            created_at: chat.created_at,
            hovered:false
          });
        });
        console.log('获取聊天列表：',this.chats);
      });
    },
    //删除聊天记录
    deleteUserChatList(userId,chatId) {
      deleteChat(userId,chatId).then(() => {
        this.getUserChatList();
      });
    },
    //确认删除聊天记录
    verifyDeleteChat(ifDelete) {
      if(ifDelete){
        this.deleteUserChatList(this.$store.state.userId,this.chatId);
      }
      this.showDeleteWarning = false;
    },
    //修改聊天标题
    updateUserChatTitle(userId,chatId,chatTitle) {
      //console.log('修改聊天标题','userId:',userId,'chatId:',chatId,'chatTitle:',chatTitle);
      updateChatTitle(userId,chatId,this.removeThinkContent(chatTitle)).then(() => {
        console.log('修改聊天标题成功','userId:',userId,'chatId:',chatId,'chatTitle:',chatTitle);
        this.getUserChatList();
      });
    },
    //确认修改聊天标题
    verifyUpdateChatTitle(ifUpdateTitle,chatTitle) {
      if(ifUpdateTitle){
        this.updateUserChatTitle(this.$store.state.userId,this.chatId,chatTitle);
      }
      this.showInputCard = false;
    },
    goToBimPlanet() {
      // Logic for navigating to BIM planet
      this.$emit('showBimPlanet', true);
    },
    goToKnowledgeBase() {
      // Logic for navigating to knowledge base 
      this.$router.push({ path: '/knowledgebase' });
    },
    //格式化日期
    formatDate(dateString) {
      const date = new Date(dateString);
      const today = new Date();
      const diffTime = Math.abs(today - date);
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      if (diffDays === 0) {
        return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
      } else if (diffDays < 7) {
        return date.toLocaleDateString([], { weekday: "long" });
      } else if (diffDays < 30) {
        return date.toLocaleDateString([], { month: "short", day: "numeric" });
      } else {
        return date.toLocaleDateString([], { month: "short", day: "numeric" });
      }
    },
  },
  computed: {
    // 从 store 获取折叠状态
    isCollapsed: {
      get() {
        return this.$store.state.isChatListCollapsed;
      },
      set(value) {
        this.$store.commit('setChatListCollapsed', value);
      }
    }
  },
};
</script>

<style scoped>
button{
  cursor: pointer;
}
.chatListContainer{
  background-color:#F4F7FF ;
  width: 300px;
  transition: width 0.3s ease;
  position: relative;
}

.chatListContainer.collapsed {
  width: 0px;
  max-width: 0px;
}

.toggle-button {
  position: absolute;
  top: 20px;
  right: -30px;
  width: 30px;
  height: 30px;
  background-color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  z-index: 100;
  transition: all 0.3s ease;
}
.toggle-button.active {
  top: 100px;
}

.toggle-button img {
  width: 18px;
  height: 18px;
}

.toggle-button:hover {
  background-color: #f0f0f0;
}
.chatList::-webkit-scrollbar {
    width: 8px;
    }

    .chatList::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
    }

    .chatList::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
    }

    .chatList::-webkit-scrollbar-thumb:hover {
    background: #555;
    }
.chatList{
  position: fixed;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
}
.buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 290px;
  height: 45px;
  margin-top: 84px;
  margin-left: 5px;
  background-color: white;
  border-radius: 10px;

  img{
    width: 22px;
    height: 22px;
  }
  button{
    height: 32px;
    color:  #4A90E2;
    font-size: 16px;
    font-family: pingFangSC;
    font-weight: 1000;
    border: 0px;
    background: white;
  }
  button:hover{
    font-size:18px;
  }
}

.chat-item {
  display: flex;
  position: relative;
  align-items: center;
  margin-left: 20px;
  margin-top: 10px;
  width: 270px;
  height: 30px;
  padding: 10px;
  border-radius: 10px;
  .delete-chat{
    position: absolute;
    right: 0px;
    button{
      background: url('../../assets/images/deleteIcon.png') no-repeat;
      background-size:contain ;
      width: 16px;
      height: 16px;
      border: 0;
    }
  }
  .modify-title{
    position: absolute;
    right: 20px;
    button{
      background: url('../../assets/images/modifyIcon.png') no-repeat;
      background-size:contain ;
      width: 16px;
      height: 16px;
      border: 0;
    }
  }
}
.chat-item:hover {
  background-color: rgba(50, 108, 255, 0.144);

}
.chat-title {
  font-weight: bold;
  font-size: 14px;
  left: 0;
}

.chat-date {
  position: absolute;
  font-size: 12px;
  color: gray;
  right: 40px;
}
.delete-chat{
  position: absolute;
  right: 10px;
}

/* 手机端响应式样式 */
@media (max-width: 768px) {
  .chatListContainer {
    width: 100%;
    min-width: 280px;
  }
  
  .chatListContainer.collapsed {
    width: 0px;
    min-width: 0px;
  }
  

  
  .toggle-button img {
    width: 15px;
    height: 15px;
  }
  
  .buttons {
    width: 95%;
    margin-left: 2.5%;
  }
  
}
</style>
